// Module
var code = `<table class="table" ng-if="\$ctrl.role">
  <tr>
    <th>Permission</th>
    <th>Description</th>
    <th>Access</th>
  </tr>

  <tr ng-repeat="p in \$ctrl.permissions | orderBy:'name'">
    <td>{{p.name}}</td>
    <td>{{p.description}}</td>
    <td>
      <input type="checkbox" ng-model="p.roleHasPermission" ng-change="\$ctrl.updatePermission(p)">
    </td>
  </tr>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-read-access/role-read-access.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;